/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agents_LeadInputs */

const en_mk_sol_agents_lead = /** @type {(inputs: Mk_Sol_Agents_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each division gets one agent. Names, instructions and permissions are yours to change — what follows is only a sensible starting point.`)
};

const id_mk_sol_agents_lead = /** @type {(inputs: Mk_Sol_Agents_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap divisi mendapat satu agen. Nama, instruksi, dan izinnya bisa Anda ubah — yang di bawah hanya titik awal yang wajar.`)
};

/**
* | output |
* | --- |
* | "Each division gets one agent. Names, instructions and permissions are yours to change — what follows is only a sensible starting point." |
*
* @param {Mk_Sol_Agents_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agents_lead = /** @type {((inputs?: Mk_Sol_Agents_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agents_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agents_lead(inputs)
	return en_mk_sol_agents_lead(inputs)
});